"use strict";

exports.__esModule = true;
exports.sortRecentPosts = exports.sortProfilePosts = exports.sortFeedPosts = exports.sortDrafts = exports.sortCategoryPosts = void 0;

var _require = require('lodash'),
    sortBy = _require.sortBy,
    intersection = _require.intersection;

var toDate = require('./to-date');

var sortFeedPosts = function sortFeedPosts(posts) {
  if (posts === void 0) {
    posts = [];
  }

  return sortBy(posts, [function (post) {
    return !post.isPinned;
  }, function (post) {
    return -toDate(post.firstPublishedDate);
  }]);
};

exports.sortFeedPosts = sortFeedPosts;

var sortCategoryPosts = function sortCategoryPosts(posts) {
  if (posts === void 0) {
    posts = [];
  }

  return sortBy(posts, function (post) {
    return -toDate(post.firstPublishedDate);
  });
};

exports.sortCategoryPosts = sortCategoryPosts;

var sortDrafts = function sortDrafts(posts) {
  if (posts === void 0) {
    posts = [];
  }

  return sortBy(posts, function (post) {
    return -toDate(post.draft.editedDate);
  });
};

exports.sortDrafts = sortDrafts;
var sortProfilePosts = sortCategoryPosts;
exports.sortProfilePosts = sortProfilePosts;

var sortRecentPosts = function sortRecentPosts(posts, categoryIds) {
  if (posts === void 0) {
    posts = [];
  }

  return sortBy(posts, [function (post) {
    return -intersection(post.categoryIds, categoryIds).length;
  }, function (post) {
    return -toDate(post.firstPublishedDate);
  }]);
};

exports.sortRecentPosts = sortRecentPosts;